export const CONTEXT_MENU_SHOW = 'CONTEXT_MENU_SHOW';
export const CONTEXT_MENU_HIDE = 'CONTEXT_MENU_HIDE';
